import './style.css';
import Hamburger from "hamburger-react";
import lupa from '../../img/lupa.png';
import lupaNegra from '../../img/lupaNegra.png';
import { useLocation } from 'react-router-dom';

function Header(props) {
    const location = useLocation();

    return ( 
            <div className={`row p-0 m-0 header ${(props.showMenu || props.showBusqueda || (location.pathname !== '/' && location.pathname !== '/nuestrotrabajo')) && "menuAbierto"}`}>
                <div className="col-2 d-sm-none mb-3 mt-auto">
                    <div className={`containerBotones " ${(props.showMenu || props.showBusqueda) ? "containerBotones-hidden" : "containerBotones-visible"}`}>
                        <div className={`containerLupa ${(location.pathname !== '/nuestrotrabajo' && location.pathname !== '/') ? 'd-none' : 'd-flex'} px-3 justify-content-center align-items-center`}>
                            <img src={lupaNegra} alt="" srcSet="" height={'55%'} className={`lupa ${(props.showMenu || props.showBusqueda) ? "lupa-hidden" : "lupa-visible"}`} onClick={() => props.showBusqueda === false && props.setShowBusqueda(true)}/>
                        </div>
                    </div>
                </div>
                <div className="col-10 d-none d-sm-flex"></div>
                <div className={`col-8 d-sm-none ${location.pathname === '/nuestrotrabajo' && 'd-flex justify-content-center pt-4'}`}>
                    <h4 className={`${location.pathname !== '/nuestrotrabajo' && 'd-none'}`}>Proyectos</h4>
                </div>
                <div className="col-2 d-flex justify-content-end mb-3 mt-auto">
                    <div className={`containerBotones " ${(props.showMenu || props.showBusqueda) ? "containerBotones-hidden" : "containerBotones-visible"}`}>
                        <div className={`containerLupa ${location.pathname === '/nuestrotrabajo' ? 'd-none' : 'd-none d-sm-flex'} px-3 justify-content-center align-items-center`}>
                            <img src={lupa} alt="" srcSet="" height={'55%'} className={`lupa ${props.showMenu ? "lupa-hidden" : "lupa-visible"}`} onClick={() => props.showBusqueda === false && props.setShowBusqueda(true)}/>
                        </div>
                        <div className="containerHamburguer d-flex px-3 justify-content-center align-items-center">
                            <Hamburger toggled={props.showMenu || props.showBusqueda} toggle={props.setShowMenu} onToggle={() => props.showBusqueda === true && props.setShowBusqueda(false)} color={ (props.showMenu || props.showBusqueda) ? "#080A26" : "#D3DDE9" } rounded duration={0.1} distance="lg"/>
                        </div>
                    </div>
                </div>
            </div>
     );
}

export default Header;